let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("edF8y")).then(() => parcelRequire('i6OLs'));